import React from 'react';
import MediaPreviewDialog from 'application/components/MediaPreviewDialog';
import { VideoPreview } from './VideoPreview';
import { ImagePreview } from './ImagePreview';
import { DATA_TEST_IDS } from '../consts';
import { VideoMediafilePreviewProps } from './types';
import styles from './index.module.scss';

export const VideoMediafilePreview: React.FC<VideoMediafilePreviewProps> = ({ url, isVideo, onClose }) => (
  <MediaPreviewDialog
    onClose={onClose}
    layoutClassName={styles.layout}
    overlayClassName={styles.overlay}
    backButtonClassName={styles.chevronLeft}
    modalTestId={DATA_TEST_IDS.MODAL}
    closeTestId={DATA_TEST_IDS.CLOSE}>
    {isVideo ? <VideoPreview url={url} /> : <ImagePreview url={url} />}
  </MediaPreviewDialog>
);
